const additionalsKeys = {
  module: ['additionals'] as const,
  list: () => [...additionalsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...additionalsKeys.list(), filters] as const,
  details: (id: string) => [...additionalsKeys.module, 'details', id] as const,
};

export default additionalsKeys;
